<template>
  <div
    v-for="(contentSection, index) in contentSections"
    :key="index"
    class="mb-12 mt-8 content-sections"
  >
    <!-- Text content-section -->
    <ArticleText
      v-if="contentSection.type === CONTENT_SECTION_TYPE_TEXT"
      class-name="contentSection"
      :text="contentSection.content"
    />

    <!-- Image content-section -->
    <img
      v-if="contentSection.type === CONTENT_SECTION_TYPE_IMAGE"
      :src="contentSection.content"
      class="mx-auto py-4"
      :alt="contentSection.contentDescription"
    />

    <!-- Internal link content-section -->
    <InternalLink
      v-if="contentSection.type === CONTENT_SECTION_TYPE_LINK"
      :content-section="contentSection"
      :category-name="categoryName"
      :content="contentSection.content"
      class="mt-16 mx-auto"
    />

    <!-- PDF content-section -->
    <PDFContentSection
      v-if="contentSection.type === CONTENT_SECTION_TYPE_PDF"
      :content-section="contentSection"
    />

    <!-- Audio content-section -->
    <AudioModal
      v-if="contentSection.type === CONTENT_SECTION_TYPE_AUDIO"
      :thumbnail="contentSection.thumbnailImageURL"
      :button-text="contentSection.contentDescription"
      :audio="contentSection.content"
    />

    <!-- Video content-section -->
    <VideoModal
      v-if="contentSection.type === CONTENT_SECTION_TYPE_VIDEO"
      :thumbnail="contentSection.thumbnailImageURL"
      :button-text="contentSection.contentDescription"
      :video="contentSection.content"
    />

    <!-- Video Link content-section -->
    <VideoLink
      v-if="contentSection.type === CONTENT_SECTION_TYPE_VIDEO_LINK"
      :i-frame-video-url="contentSection.iFrameVideoUrl"
    />

    <!-- Appointment content-section -->
    <ArticleAppointment
      v-if="contentSection.type === CONTENT_SECTION_TYPE_APPOINTMENT"
      :content-section="contentSection"
    />

    <!-- Custom Challenge content-section -->
    <CustomChallengeButton
      v-if="contentSection.type === CONTENT_SECTION_TYPE_CUSTOM_CHALLENGE"
      :id="contentSection.customChallengeId"
      :label="contentSection.content ?? contentSection.customChallengeName"
      :challenge-type="contentSection.type"
    />

    <!-- Competitive Challenge content-section -->
    <CompetitiveChallengeButton
      v-if="contentSection.type === CONTENT_SECTION_TYPE_COMPETITIVE_CHALLENGE"
      :id="contentSection.competitiveChallengeId"
      :label="contentSection.content ?? contentSection.customChallengeName"
      :challenge-type="contentSection.type"
    />
  </div>
</template>

<script lang="ts" setup>
import { defineProps } from "vue";
import InternalLink from "./InternalLink.vue";
import PDFContentSection from "./PDFContentSection.vue";
import AudioModal from "./AudioModal.vue";
import VideoModal from "./VideoModal.vue";
import ArticleAppointment from "./ArticleAppointment.vue";
import {
  CONTENT_SECTION_TYPE_TEXT,
  CONTENT_SECTION_TYPE_IMAGE,
  CONTENT_SECTION_TYPE_LINK,
  CONTENT_SECTION_TYPE_PDF,
  CONTENT_SECTION_TYPE_AUDIO,
  CONTENT_SECTION_TYPE_VIDEO,
  CONTENT_SECTION_TYPE_VIDEO_LINK,
  CONTENT_SECTION_TYPE_APPOINTMENT,
  CONTENT_SECTION_TYPE_CUSTOM_CHALLENGE,
  CONTENT_SECTION_TYPE_COMPETITIVE_CHALLENGE,
} from "../../../enum/v2/contentSectionType";
import VideoLink from "./VideoLink.vue";
import ArticleText from "../../../components/v2/contentSections/ArticleText.vue";
import CustomChallengeButton from "./CustomChallengeButton.vue";
import CompetitiveChallengeButton from "~/components/v2/contentSections/CompetitiveChallengeButton.vue";

const props = defineProps<{
  contentSections: any;
  categoryName?: string;
  articleId?: number;
}>();
</script>
